function searchByLetters(searchString, elements) {
	let lowerCaseSearchValue = null;
	if (!!searchString) {
		lowerCaseSearchValue = searchString.toLowerCase()
	}
	if (!!elements) {
		elements.forEach(element => {
			if (!!element.querySelectorAll(".collection-overview--link")) {
				let collectionLinks = element.querySelectorAll(".collection-overview--link")
				collectionLinks.forEach((link,i) => {
					//Check if the searched value contains collection
					const outputText = changeCharacters(link.innerText)
					const outputTextSearch = changeCharacters(lowerCaseSearchValue)
					let textValue = outputText.toLowerCase();
					if (!!lowerCaseSearchValue) {
						if (textValue.indexOf(outputTextSearch) > -1) {
							link.style.display = "block";
							link.parentNode.classList.add('child-is-shown')
							link.parentNode.classList.remove('child-is-hidden')
						} else {
							link.parentNode.classList.add('child-is-hidden')
							link.parentNode.classList.remove('child-is-shown')
							link.style.display = "none";
						}
					} else {
						link.style.display = "block";
						link.parentNode.classList.remove('child-is-shown')
						link.parentNode.classList.remove('child-is-hidden')
						// Show the filtered groupd
						if (!!document.querySelectorAll('.collection-overview--group')) {
							document.querySelectorAll('.collection-overview--group').forEach(group=>{
								if (!!group) {
									group.style.display = 'block'	
								}
							})
						}
					}
					highlightLetters(lowerCaseSearchValue,link)
				})
			}
		});
	}
	hideGroups()
	createLinkToCollection(lowerCaseSearchValue)
}

function changeCharacters(text) {
	if (!!text) {
		return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}
}
function highlightLetters(searchValue,originalEl) {
	if (!!originalEl) {
		const textToHighlight = originalEl.innerHTML;
		const highlightedText = textToHighlight.replace(/<span class="highlight">|<\/span>/g, '');
		if (!!searchValue) {
			const regex = new RegExp(searchValue, 'gi');
			const newText = highlightedText.replace(regex, '<span class="highlight">$&</span>');
			originalEl.innerHTML = newText
		} else {
			highlightedText = textToHighlight.replace(/<span class="highlight">|<\/span>/g, '');
			originalEl.innerText = highlightedText
		}
	}
}
function createLinkToCollection(lowerCaseSearchValue) {
	let activeLinks = document.querySelectorAll('.child-is-shown')
	let activeLinksArr = []

	if (!!activeLinks) {
		activeLinks.forEach(activeLink => {
			let collectionLink = activeLink.querySelectorAll('.collection-overview--link')
			collectionLink.forEach(link=>{
 				let capitalizedString = link.innerHTML.replace(/<span class="highlight">|<\/span>/g, '')
				capitalizedString = capitalizedString.replace('&amp;', '%26')
 				let producerName = `filter.p.m.meta.producer=${capitalizedString.replace(/\s+/g, "+")}`;
 				activeLinksArr.push(producerName)
			})
		})
		if(!!document.querySelector('.collection-overview-result')){
			let overviewResult = document.querySelector('.collection-overview-result')
			if (activeLinksArr.length) {
				let collectionLinkEl = `${window.location.origin}/collections/all?&${activeLinksArr.join('&')}`
				overviewResult.innerHTML = window.languages.searchResultCollection
				overviewResult.href = collectionLinkEl
				if (!!document.querySelector('.collection-overview--main-letters')) {
					document.querySelector('.collection-overview--main-letters').style.display = "flex";
				}
			} else {
				overviewResult.innerHTML = ''
				overviewResult.href = '#'
				if (!!lowerCaseSearchValue) {
					overviewResult.innerHTML = window.languages.noSearchResultCollection
					if (!!document.querySelector('.collection-overview--main-letters')) {
						document.querySelector('.collection-overview--main-letters').style.display = "none";
					}
				}
			}
		}
	}
}
function hideGroups(){
	if(!!document.querySelectorAll('.collection-overview')){
		// Get all elements with the class "collection-overview'"
		const groupChildren = document.querySelectorAll('.collection-overview');
		// Filter out the parents where all children have the class "child-is-hidden"
		const groupCildrenToHide = Array.from(groupChildren).filter(groupChild => {
			if(!!groupChild.querySelectorAll('.child-is-hidden')){
				const children = groupChild.querySelectorAll('.child-is-hidden');
				return groupChild.children.length === children.length;
			}
		});
		// Hide the filtered groupd
		if (!!groupCildrenToHide && groupCildrenToHide.length) {
			groupCildrenToHide.forEach(groupCild=>{
				if (!!groupCild.parentNode) {
					if (!groupCild.classList.contains('.child-is-shown')) {
						groupCild.parentNode.style.display = 'none'
					}
				}
			})
		}
		// Show the filtered groupd
		if (!!document.querySelectorAll('.child-is-shown')) {
			document.querySelectorAll('.child-is-shown').forEach(groupCild=>{
				if (!!groupCild.parentNode) {
					groupCild.parentNode.parentNode.style.display = 'block'	
				}
			})
		} 
	}
}

function sortNodesAlphabetically(a, b) {
	let textA = a.textContent.trim().toLowerCase();
	let textB = b.textContent.trim().toLowerCase();
	if (textA.startsWith("á") && !textB.startsWith("á")) {
		return 1;
	} else if (!textA.startsWith("á") && textB.startsWith("á")) {
		return -1;
	} else {
		return textA.localeCompare(textB);
	}
}

function sortNodes(array) {
	if (!!array) {
		let nodesArray = Array.from(array).sort(sortNodesAlphabetically);
		let collectionOverview = document.querySelectorAll('.collection-overview--item')
		nodesArray.forEach(function (node, i) { 
			let newLink = document.createElement('a')
			newLink.href = `${node.href}`
			newLink.id=`${node.innerHTML}`
			newLink.innerText =`${node.innerHTML.replace('&amp;','&')}`
			newLink.className = "collection-overview--link link"

			collectionOverview[i].innerHTML = ''
			collectionOverview[i].appendChild(newLink)
		});
	}
}

document.addEventListener("DOMContentLoaded", function () {
	if (!!document.querySelectorAll('.collection-overview--link')) {
		sortNodes(document.querySelectorAll('.collection-overview--link'))
	}
	if (!!document.querySelectorAll('.collection-overview--group')) {
		const collectionOverviewLinks = document.querySelectorAll('.collection-overview--group')
		if (!!document.querySelector('.collection-overview--search__input')) {
			const searchInput = document.querySelector('.collection-overview--search__input')
			searchInput.addEventListener('input', function (e) {
				const searchString = e.target.value.trim();
				searchByLetters(searchString, collectionOverviewLinks)
			})
		}
	}
})
